const initBtnLoading = () => {
  const forms = document.querySelectorAll('form');
  if(forms){
    forms.forEach((form) => {
      const submitButton = form.querySelector('button[type="submit"]:not(.no-loader)');
      if(submitButton){
        form.addEventListener('submit', (event) => {
          if(event.submitter && event.submitter.nodeName === 'BUTTON' && !event.submitter.hasAttribute('type')){
            return false; //workaround for onboarding date of birth datepicker
          }

          if(form.checkValidity() &&
           (!form.classList.contains('need-checks') || (form.classList.contains('need-checks') && form.classList.contains('checks-validated')))){
            const clonedButton = submitButton.cloneNode();

            const btnHeight = submitButton.offsetHeight;
            const btnWidth = submitButton.offsetWidth;
            clonedButton.style.height = btnHeight+'px';
            clonedButton.style.width = btnWidth+'px';

            clonedButton.innerHTML = `
                <div class="btn-loader" style="width: ${btnHeight}px"></div>
            `;

            submitButton.parentNode.insertBefore(clonedButton, submitButton);

            const loader = clonedButton.querySelector(".btn-loader");
            if(loader){
              const loaderHeight = loader.offsetHeight;

              loader.style.width = loaderHeight+'px';

              submitButton.classList.add('hidden');
              submitButton.classList.add('originalButton');

              clonedButton.classList.add('clonedButton');
              clonedButton.disabled = true;
            }
          }
        });
      }
    });
  }
}

export { initBtnLoading }
